import GpsUnavailableView from 'containers/settings/subscriptions/GpsUnavailableView/GpsUnavailableView';
import { useOpenable } from 'hooks';
import { IChildrenProps } from 'types/ChildrenProps';
import { MapNavGuardContext } from './MapNavGuardContext';

const MapNavGuardProvider = ({ children }: IChildrenProps) => {
  const gpsUnavailableOpenable = useOpenable();

  return (
    <MapNavGuardContext.Provider value={{ openGpsUnavailable: gpsUnavailableOpenable.open }}>
      {children}
      <GpsUnavailableView isOpen={gpsUnavailableOpenable.isOpen} onClose={gpsUnavailableOpenable.close} />
    </MapNavGuardContext.Provider>
  );
};

export default MapNavGuardProvider;
